import { Product } from "../product/product";

export class LaterList {
    constructor() {
        this.owningUser = '';
        this.products = new Array<LaterListProduct>();
    }
    owningUser: string;
    products: Array<LaterListProduct>;
}

export class LaterListProduct {
    constructor() {
        this.id = '';
        this.product = new Product();
        this.image = "";
        this.quantity = 0;
        this.configurationJson = "";
    }
    id: string;
    product: Product;
    image: string;
    quantity: number;
    configurationJson: string;
}
